import axios from "axios";
import isEmpty from "is-empty";
import { GET_ERRORS, POOL_ADD, POOL_UPDATE } from "./types";
import { db } from "../firebase";
import { collection, setDoc, doc, updateDoc } from "firebase/firestore";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";

export const addPool = (param, history) => async (dispatch) => {
  var poolData = new FormData();
  poolData.append("risk", 5);
  poolData.append("pid", 0);
  poolData.append("lpSymbol", param.tokenSymbol);
  poolData.append("alloc", param.alloc * 100);
  poolData.append("isTokenOnly", true);
  poolData.append("lpAddresses", param.lpAddresses);
  poolData.append("tokenSymbol", param.tokenSymbol);
  poolData.append("tokenAddresses", param.tokenAddresses);
  poolData.append("quoteTokenSymbol", "BUSD");
  poolData.append(
    "quoteTokenAdresses",
    "0xe9e7cea3dedca5984780bafc599bd69add087d56"
  );
  poolData.append("depositFee", param.depositFee);
  poolData.append("file", param.file);

  const storage = getStorage();
  const storageRef = ref(storage, `images/${param.file.name}`);
  // 'file' comes from the Blob or File API
  const file = param.file;
  const uploadTask = uploadBytesResumable(storageRef, file);

  uploadTask.on(
    "state_changed",
    (snapshot) => {
      // Observe state change events such as progress, pause, and resume
      // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
      const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      console.log("Upload is " + progress + "% done");
    },
    (error) => {
      // Handle unsuccessful uploads
      dispatch({
        type: GET_ERRORS,
        payload: error,
      });
    },
    () => {
      // Handle successful uploads on complete
      // For instance, get the download URL: https://firebasestorage.googleapis.com/...
      getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
        const poolRef = doc(collection(db, "pools"));
        const docRef = await setDoc(poolRef, {
          id: poolRef.id,
          risk: 5,
          pid: 0,
          lpSymbol: param.tokenSymbol,
          alloc: param.alloc * 100,
          isTokenOnly: true,
          lpAddresses: param.lpAddresses,
          tokenSymbol: param.tokenSymbol,
          tokenAddresses: param.tokenAddresses,
          quoteTokenAdresses: "BUSD",
          quoteTokenAdresses: "0xe9e7cea3dedca5984780bafc599bd69add087d56",
          depositFee: param.depositFee,
          file: downloadURL,
        });
        dispatch({
          type: POOL_ADD,
          payload: poolRef,
        });
      });
    }
  );

  //console.log("formdata>>>>>>>",formData)
  // axios
  //     .post("/api/pool-add", poolData)
  //     .then(res =>{
  //         // console.log("yyyhyu>>",res)
  //         dispatch({
  //             type: POOL_ADD,
  //             payload: res,
  //         })
  //     }
  //     ).catch(err =>{
  //         // console.log("yyyhyu>>",err)
  //     dispatch({
  //         type: GET_ERRORS,
  //         payload:err.response.data
  //     })
  // }
  // );
};

export const updatePool = (param) => async (dispatch) => {
  console.log("updatePool>>>>>", param);
  var poolUpdateData = new FormData();
  let data = {};

  if (!isEmpty(param._id)) poolUpdateData.append("_id", param._id);
  poolUpdateData.append("pid", 0);
  data.pid = 0;
  if (!isEmpty(param.risk)) poolUpdateData.append("risk", param.risk);
  data.risk = param.risk;
  data.lpSymbol = param.tokenSymbol;
  poolUpdateData.append("lpSymbol", param.tokenSymbol);
  if (!isEmpty(param.alloc)) poolUpdateData.append("alloc", param.alloc * 100);
  poolUpdateData.append("isTokenOnly", true);
  data.alloc = param.alloc*100;
  data.isTokenOnly = true;
  if (!isEmpty(param.lpAddresses))
    // poolUpdateData.append("lpAddresses", param.lpAddresses);
    data.lpAddresses = param.lpAddresses
  if (!isEmpty(param.tokenSymbol))
    // poolUpdateData.append("tokenSymbol", param.tokenSymbol);
    data.tokenSymbol = param.tokenSymbol
  if (!isEmpty(param.tokenAddresses))
    // poolUpdateData.append("tokenAddresses", param.tokenAddresses);
    data.tokenAddresses = param.tokenAddresses;
  if (!isEmpty(param.quoteTokenSymbol))
    // poolUpdateData.append("quoteTokenSymbol", "BUSD");
    data.quoteTokenSymbol = "BUSD"
  if (!isEmpty(param.quoteTokenAdresses))
    // poolUpdateData.append(
    //   "quoteTokenAdresses",
    //   "0xe9e7cea3dedca5984780bafc599bd69add087d56"
    // );
    data.quoteTokenAdresses = "0xe9e7cea3dedca5984780bafc599bd69add087d56"
  if (!isEmpty(param.depositFee))
    // poolUpdateData.append("depositFee", param.depositFee);
    data.depositFee = param.depositFee;
  if (!isEmpty(param.file)) {
    poolUpdateData.append("file", param.file);
    console.log("1111111", poolUpdateData);
    data.file = param.file;
  } else {
    console.log("222222222");
  }


  if (!isEmpty(param.file)) {
    const storage = getStorage();
    const storageRef = ref(storage, `images/${param.file.name}`);
    // 'file' comes from the Blob or File API
    const file = param.file;
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
        (snapshot) => {
        // Observe state change events such as progress, pause, and resume
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log("Upload is " + progress + "% done");
      },
      (error) => {
        // Handle unsuccessful uploads
        dispatch({
          type: GET_ERRORS,
          payload: error,
        });
      },
    () => {
        // Handle successful uploads on complete
        // For instance, get the download URL: https://firebasestorage.googleapis.com/...
        getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
          const poolRef = doc(db, "pools", param._id);
          const docRef = await updateDoc(poolRef, {
            ...data,
            file: downloadURL,
          });
          dispatch({
            type: POOL_UPDATE,
            payload: poolRef,
          });
        });
      }
    );
  } else {
    const poolRef = doc(db, "pools", param._id);
    const docRef = await updateDoc(poolRef, data);
    dispatch({
      type: POOL_UPDATE,
      payload: poolRef,
    });
  }


//   // console.log("poolUpdateData>>>>>",poolUpdateData)
//   axios
//     .post("/api/pool-update", poolUpdateData)
//     .then((res) =>
//       dispatch({
//         type: POOL_UPDATE,
//         payload: res,
//       })
//     )
//     .catch((err) =>
//       dispatch({
//         type: GET_ERRORS,
//         payload: err.response.data,
//       })
//     );
};
